export const MILEAGE_RECORDS_PATH = 'fit_diary_zone_five_2610';
export const MILEAGE_PRIZES_PATH = 'fit_diary_zone_five_settings/prizes';
export const defaultMileagePrizes = () => ({
    first: '가민 포러너 165 (250,000원)', second: '상품권 (100,000원)',
    third: '상품권 (80,000원)', fourth: '코브라 아레나 수경 (70,000원)',
    fifth: '음파 노패킹 수경 (30,000원)', lucky: '미정'
});
export const mileagePrizeLabels = { first: '1등', second: '2등', third: '3등', fourth: '4등', fifth: '5등', lucky: '럭키상' };
export function mileagePrizesFrom(value) {
    const prizes = defaultMileagePrizes();
    Object.keys(prizes).forEach(key => {
        if (value && typeof value[key] === 'string' && value[key].trim()) prizes[key] = value[key];
    });
    return prizes;
}
